import { createContext } from "react";

const BreadCrumbsRoutes = createContext([]);

export default BreadCrumbsRoutes;
